import { useState } from 'react';
import React from "react";
import rectangle1 from '../assets/Rectangle 18221.svg'
import './buysellforex.css';

function BuySellForex() {
    const [tab, setTab] = useState('buy'); 

    
    const handleTabClick = (tabName) => {
        setTab(tabName);
    };

    return (
        <div>
            <div className="forexbuttoncontainer">
                <div
                    className={`forexbutton${tab === 'buy' ? '-active' : ''}`}
                    onClick={() => handleTabClick('buy')}
                >
                    Buy Forex
                </div>
                <div
                    className={`forexbutton${tab === 'sell' ? '-active' : ''}`}
                    onClick={() => handleTabClick('sell')}
                >
                    Sell Forex
                </div>
            </div>

        <div className='forextab'>
                
            <div>
                {tab === 'buy' && (
                    <div>
                    <form className='forexform'>
                            <div className='forexinput'>

                            <label htmlFor="city" className=''>Select City</label>
                            <select name="city" id="city">
                                <option value="usd">Bokaro</option>
                                <option value="eur">Bangalore</option>
                                <option value="gbp">Manipal</option>
                                <option value="jpy">Ranchi</option>
                            </select>

                            </div>
                            
                            <div style={{display:'flex',flexDirection:'row',justifyContent:'space-between'}}>

                                <div className='forexinput' style={{width:'100%',margin:'5px'}}>
                                    <label htmlFor="currency">Your Currency</label>
                                    <select name="currency" id="currency">
                                        <option value="usd">USD</option>
                                        <option value="eur">EUR</option>
                                        <option value="gbp">GBP</option>
                                        <option value="jpy">JPY</option>
                                    </select>
                                </div>

                                <div className='forexinput' style={{width:'100%',margin:'5px'}}>
                                    <label htmlFor="currency">Currency you want</label>
                                    <select name="currency" id="currency">
                                        <option value="usd">USD</option>
                                        <option value="eur">EUR</option>
                                        <option value="gbp">GBP</option>
                                        <option value="jpy">JPY</option>
                                    </select>
                                </div>


                            </div>
                            
                            <div className='forexinput'>
                                <label htmlFor="amount">Forex Amount</label>
                                <div style={{display:'flex',flexDirection:'row'}}>
                                    <div style={{backgroundColor:'#000000',border:'1px solid #541C9C',width:'20%',padding:'10px',margin:'10px 0px',borderTopLeftRadius:'30px',borderBottomLeftRadius:'30px',display:'flex',justifyContent:'center',alignItems:'center'}}>$</div>
                                    <input type="number" id="amount" name="amount" />
                                </div>
                            </div>

                            <div className='forexinput'>
                                <label htmlFor="amount">INR Amount</label>
                                <div style={{display:'flex',flexDirection:'row'}}>
                                    <div style={{backgroundColor:'#000000',border:'1px solid #541C9C',width:'20%',padding:'10px',margin:'10px 0px',borderTopLeftRadius:'30px',borderBottomLeftRadius:'30px',display:'flex',justifyContent:'center',alignItems:'center'}}>$</div>
                                    <input type="number" id="amount" name="amount" />
                                </div>
                            </div>

                            <button className='ctabutton' type="submit">Sell</button>
                        </form>
                </div>
                )}

                {tab === 'sell' && (
                    <div>
                        <form className='forexform'>
                            <div className='forexinput'>

                            <label htmlFor="city" className=''>Select City</label>
                            <select name="city" id="city">
                                <option value="usd">Bokaro</option>
                                <option value="eur">Bangalore</option>
                                <option value="gbp">Manipal</option>
                                <option value="jpy">Ranchi</option>
                            </select>

                            </div>
                            
                            <div style={{display:'flex',flexDirection:'row',justifyContent:'space-between'}}>

                                <div className='forexinput' style={{width:'100%',margin:'5px'}}>
                                    <label htmlFor="currency">Your Currency</label>
                                    <select name="currency" id="currency">
                                        <option value="usd">USD</option>
                                        <option value="eur">EUR</option>
                                        <option value="gbp">GBP</option>
                                        <option value="jpy">JPY</option>
                                    </select>
                                </div>

                                <div className='forexinput' style={{width:'100%',margin:'5px'}}>
                                    <label htmlFor="currency">Currency you want</label>
                                    <select name="currency" id="currency">
                                        <option value="usd">USD</option>
                                        <option value="eur">EUR</option>
                                        <option value="gbp">GBP</option>
                                        <option value="jpy">JPY</option>
                                    </select>
                                </div>


                            </div>
                            
                            <div className='forexinput'>
                                <label htmlFor="amount">Forex Amount</label>
                                <div style={{display:'flex',flexDirection:'row'}}>
                                    <div style={{backgroundColor:'#000000',border:'1px solid #541C9C',width:'20%',padding:'10px',margin:'10px 0px',borderTopLeftRadius:'30px',borderBottomLeftRadius:'30px',display:'flex',justifyContent:'center',alignItems:'center'}}>$</div>
                                    <input type="number" id="amount" name="amount" />
                                </div>
                            </div>

                            <div className='forexinput'>
                                <label htmlFor="amount">INR Amount</label>
                                <div style={{display:'flex',flexDirection:'row'}}>
                                    <div style={{backgroundColor:'#000000',border:'1px solid #541C9C',width:'20%',padding:'10px',margin:'10px 0px',borderTopLeftRadius:'30px',borderBottomLeftRadius:'30px',display:'flex',justifyContent:'center',alignItems:'center'}}>$</div>
                                    <input type="number" id="amount" name="amount" />
                                </div>
                            </div>

                            <button className='ctabutton' type="submit">Sell</button>
                        </form>
                    </div>
                )}
            </div>

            <div className='forexfiller'>
                <div>
                    <img className='coin' style={{height:'auto',width:'80%'}} src={rectangle1} alt="Forex Info" />
                </div>
                <div style={{padding:'10px'}}>
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute.
                </div>
            </div>

        </div>
        </div>
    );
}

export default BuySellForex;
